import { render, staticRenderFns } from "./TipEdit.vue?vue&type=template&id=09d4e6b4&"
import script from "./TipEdit.vue?vue&type=script&lang=js&"
export * from "./TipEdit.vue?vue&type=script&lang=js&"
import style0 from "./TipEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports